export default {
	lang: 'de',
	roof: 'Dach',
	facade: 'Fassade',
	searchForAddress: 'Hier Adresse eingeben...',
	address: 'Adresse',
	map: 'Karte',
	or: 'oder',
	clickOn: 'Klicke auf ein Dach auf der',
	selectedAddress: 'Ausgewählte Adresse',
	notYetLocalised: 'Noch nicht lokalisiert',
	indicateLocation: 'Gib deinen Standort an',
	whatRoofType: 'Welche Dachart haben Sie?',
	unselected: 'Dachart wählen',
	tile: 'Ziegel',
	tin: 'Blech',
	other: 'Andere / Unbekannt',
	corrugatedEternit: 'Wellplatten-Eternit',
	slateEternit: 'Schiefer-Eternit',
	gravel: 'Kies-Flachdach',
	substrate: 'Substrat-Flachdach',
	wallbox: 'Wallbox',
	wallboxDescription: 'Die Installation einer Wallbox ist eine zukunftsorientierte Investition in die bestehende Infrastruktur. Durch intelligente Interaktion mit der Solaranlage kann Ihre Fuhrpark heute oder in Zukunft mit günstigem Strom versorgt werden.', // this string needs to be exactly this length or shorter.
	backupPower: 'Notstrom bei Netzausfall',
	backupPowerDescription: 'Selbst bei einem Stromausfall versorgt die Solaranlage weiterhin die wichtigsten Anlagen mit Strom. In der Regel handelt es sich dabei um Geräte wie Gefrierschränke, Leuchten und Telefon & Internet.', // this string needs to be exactly this length or shorter.
	additionalOfferings: 'Zusätzliche Angebote',
	yourLocation: 'Dachstandort & Kontakt',
	mr: 'Herr',
	mrs: 'Frau',
	firstName: 'Vorname',
	surname: 'Nachname',
	email: 'E-Mail',
	phone: 'Telefon',
	postalCode: 'Postleitzahl',
	city: 'Stadt',
	addressCap: 'Adresse',
	comments: 'Bemerkungen',
	addressSameAsAbove: 'Adresse ist dieselbe wie oben',
	state: 'Kanton',
	street: 'Strasse',
	submit: 'Absenden',
	invalidEmail: 'Ungültige E-Mail-Adresse',
	invalidPhone: 'Ungültige Telefonnummer',
	invalidCaptcha: 'CAPTCHA Token ist nicht gültig',
	submissionComplete: 'Einsendung abgeschlossen ',
	sendingData: 'Informationen werden gesendet...',
	submissionError: 'Ein Fehler ist aufgetreten!',
	apiErrorMessage: 'Dienst nicht verfügbar: Ihre Anfrage kann derzeit nicht bearbeitet werden.',
	apiInvalidCaptchaMessage: 'Ihr CAPTCHA-Token ist ungültig oder abgelaufen. Bitte aktualisieren Sie die Seite und versuchen Sie es erneut.',
	mandatoryField: 'Feld darf nicht leer sein',
	enterCustom: 'Bitte geben Sie Ihre Benutzerdefinierten Daten ein',
	customRoof: 'Zurück zur Karte',
	mapMode: 'Manuelle Eingabe',
	length: 'Länge',
	width: 'Breite',
	unit: 'm',
	area: 'Fläche',
	slope: 'Neigung',
	data: 'Daten',
	pleaseEnter: 'Bitte geben Sie Ihre Dachadresse ein oder fügen Sie Ihre benutzerdefinierten Dachdaten hinzu',
	selectRoofType: 'Bitte geben Sie Ihren Dachtyp ein',
	multipleRoofLabel: 'Mehrere Dächer',
	clearRoofSelectionLabel: 'Reset',
	orientation: 'Dachausrichtung',
	north: 'N',
	northeast: 'NO',
	east: 'O',
	southeast: 'SO',
	south: 'S',
	southwest: 'SW',
	west: 'W',
	northwest: 'NW',
	roof1: 'Dach 1',
	electricityProductionPerYear: 'Stromproduktion pro Jahr',
	electricityProductionPerYearUnit: 'kWh',
	amountOfHouseholds: 'Anzahl Haushalte',
	financialReturnIn30years: 'Ertrag in 30 Jahren',
	financialReturnIn30yearsUnit: 'CHF',
	deleteTab: 'Dach löschen',
	removeRoof: 'Dach entfernen',
	undo: 'Rückgängig',
	removed: 'entfernt',
	welcomeMessage: 'Ihre persönliche Solar-Offerte in drei Minuten',
	cookieConsentBanner1: 'Unsere Webseite setzt Tracking-Cookies ein, um detaillierte Analysen durchzuführen und Marketingmassnahmen zu optimieren.',
	cookieConsentBanner2: 'So können wir Ihr Nutzererlebnis kontinuierlich verbessern.',
	acceptButtonText: 'Akzeptieren',
	declineButtonText: 'Ablehnen',
	title: "Solar-Rechner von Elektrobedarf Troller",
	description: "Strom durch Sonnenlicht - Dach auswählen, Ertrag berechnen und Angebot anfordern.", // Add the description,
	publisher: "Herausgeber und verantwortlich für den Inhalt: Patrick Troller, Geschäftsführer",
	development: "Entwicklung:",
	t2consultAddress: "Am Heidberg 14, 24211 Preetz - Deutschland",
	additionalSuccessMessage: "Vielen Dank! Ihr persönlicher Solarberater erstellt nun Ihre individuelle Offerte.",
	consultantHint: "ⓘ Jede Offerte wird persönlich von einem Solarexperten geprüft und auf Ihr Dach zugeschnitten. Ihre Daten werden vertraulich behandelt und nicht an Dritte weitergegeben.",
	nextStep: "Weiter",
	nextToRoofType: "Weiter zur Dachart",
	roofType: "Dachart",
	directContact: "Kontaktaufnahme",
	nextToTeaser: "Weiter zur Übersicht",
	nextToOfferings: "Weiter zu den Angeboten",
	nextToContact: "Weiter zum Kontaktformular",
	backToAddress: "Zurück zur Adresse",
	backToRoofType: "Zurück zur Dachart",
	backToTeaser: "Zurück zur Übersicht",
	backToOfferings: "Zurück zu den Angeboten",
	teaserHeading: "Ihr persönliches Solarpotenzial",
	teaserSubheading: "Auf Basis dieser Daten erstellen wir Ihre individuelle Offerte.",
	offeringsHint: "Diese Optionen werden in Ihrer persönlichen Beratung detailliert besprochen.",
	solarSuitability: "Solareignung",
	solarExcellent: "Hervorragend",
	solarVeryGood: "Sehr gut",
	solarGood: "Gut",
	solarMedium: "Mittel",
	solarLow: "Gering",
	addAnotherRoof: '+ Weiteres Dach hinzufügen',
	enterAddressHint: 'Geben Sie Ihre Adresse ein oder wählen Sie Ihr Dach auf der Karte aus',
	doubleClickHint: 'Doppelklick auf ein Gebäude = ganzes Dach auswählen',
	doubleTapHint: 'Doppeltippen auf ein Gebäude = ganzes Dach auswählen',
	maxRoofsReached: 'Maximum 3 Dächer erreicht. Weitere Dächer? Bitte im Bemerkungsfeld vermerken – ein Solarexperte wird sich um Ihr Projekt kümmern.',
}
